import { render } from "./fonctions_tab.vue?vue&type=template&id=3e772b03"
import script from "./fonctions_tab.vue?vue&type=script&lang=js"
export * from "./fonctions_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__